var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconWallMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9997 23.2933H2.99967V6.99992H12.333V4.33325H2.99967C1.53301 4.33325 0.333008 5.53325 0.333008 6.99992V22.9999C0.333008 24.4666 1.53301 25.6666 2.99967 25.6666H18.9997C20.4663 25.6666 21.6663 24.4666 21.6663 22.9999V13.6666H18.9997V23.2933Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6663 0.333252H18.9997V4.33325H14.9997C15.013 4.34659 14.9997 6.99992 14.9997 6.99992H18.9997V10.9866C19.013 10.9999 21.6663 10.9866 21.6663 10.9866V6.99992H25.6663V4.33325H21.6663V0.333252Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.333 9.66659H5.66634V12.3333H16.333V9.66659Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.66634 13.6666V16.3333H16.333V13.6666H5.66634Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.333 17.6666H5.66634V20.3333H16.333V17.6666Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWallMenu);
export default __webpack_public_path__ + "static/media/icon_wall_menu.47b51ef3e76115aaeef932c5f2d59b15.svg";
export { ForwardRef as ReactComponent };